<template>
    <div id="header" class="container">
        <!-- 
        ----------------------------------------------------------------------------------------------------------
                                                    TOP NAVBAR 
        ----------------------------------------------------------------------------------------------------------
        -->
        <div id="topHeader" class="footer-test">
            <!-- <div class="reseaux-sociaux">
                <a href="https://www.facebook.com/lyceeflaubertrouen/" target="new"> 
                    <img src="@/html/elements/facebook.svg" alt="Icone réseau social Facebook">
                </a>
                <a href="https://fr.linkedin.com/company/lycee-professionnel-gustave-flaubert"  target="new">
                    <img src="@/html/elements/linkedin.svg" alt="Icone réseau social Linkedin">
                </a>
            </div> -->
            
            <div class="col-12 col-md-10 offset-md-2 col-xl-8 offset-xl-4 top-nav">
                <form action="">
                    <input type="text" class="form-search" placeholder="Recherche...">
                </form>

                <a href="erasmus-plus" class="top-nav-link erasmus">
                    <img src="@/html/elements/ico-erasmus.svg" alt="Logo d'erasmus+">
                </a>
                <div class="top-nav-link brochures" v-b-modal.modal-1>
                    <span>Brochures</span>
                </div>
                <a href="contact" class="top-nav-link contact">
                    <span>Contact</span>
                </a>
                <a href="https://connexion.l-educdenormandie.fr/" target="new" class="top-nav-link connexion">
                    <span>Connexion</span>
                </a>
            </div>

        </div>

        <!-- 
        ----------------------------------------------------------------------------------------------------------
                                                        MODAL BROCHURES
        ----------------------------------------------------------------------------------------------------------
        -->
        <b-modal id="modal-1" title="Télécharger nos brochures"
                header-bg-variant="#333333"
                header-text-variant="white"
                body-bg-variant="#333333"
                body-text-variant="white"
                hide-footer>

                <div class="accordion" role="tablist">
                    <b-list-group>
                        <b-list-group-item  no-body class="m-0 p-0" v-for="(folder, index) in this.childListFolder" :key="index">
                            <b-card-header header-tag="header" class="p-2 border-b border-solid border-transparent" role="tab">
                                <div block  v-b-toggle="'accordion-'+folder.id" >
                                    <feather-icon class="pull-left m-0 mr-1" icon='ChevronRightIcon' svgClasses='h-6 w-6' /> {{folder.caption}}</div>
                            </b-card-header>
                            <b-collapse :id="'accordion-'+folder.id" class="p-2"  :accordion="'accordion-'+folder.id" role="tabpanel">
                                <a
                                    :href="item.download"
                                    v-for="(item, index) in filterChildFile(folder.id) "
                                    :key="index"
                                    target="new"
                                    class="p-1"
                                    style="background-transparent; color:#f1f1f1; width:100%; display:block; text-decoration:none"
                                >
                                    {{formatNameFile(item.caption)}}
                                    <feather-icon class="pull-right m-0" icon='FileIcon' svgClasses='h-4 w-4' />
                                </a>
                            </b-collapse>
                        </b-list-group-item>
                        <b-list-group-item no-body class="m-0 p-0" >
                            <b-card-header header-tag="header" class="p-2 border-b border-solid border-transparent" role="tab">
                                <div block v-b-toggle.accordion-autres><feather-icon class="pull-left m-0 mr-1" icon='ChevronRightIcon' svgClasses='h-6 w-6' /> Autres</div>
                            </b-card-header>
                            <b-collapse id="accordion-autres" class="p-2"  accordion="accordion-autres" role="tabpanel">
                                <div
                                    :href="item.download"
                                    v-for="(item, index) in filterChildFile('WHRKMF77QzDtrBhkLxX6') "
                                    :key="index"
                                    target="new"
                                    class="p-1"
                                    style="background-transparent"
                                >
                                    {{item.caption}}
                                    <feather-icon class="pull-right m-0" icon='FileIcon' svgClasses='h-4 w-4' />
                                </div>
                            </b-collapse>
                        </b-list-group-item>
                    </b-list-group>
                </div>


            
        </b-modal>

        <!-- 
        ----------------------------------------------------------------------------------------------------------
                                                        NAVBAR
        ----------------------------------------------------------------------------------------------------------
        -->
        <nav class="navbar navbar-light navbar-expand-md" id="headerNavbar">
            <!-- 
            ----------------------------------------------------------------------------------------------------------
                                                            LOGO
            ----------------------------------------------------------------------------------------------------------
            -->
            <router-link  
                class="navbar-brand"
                :to="{  path:'/accueil'}"
            >
                <img src="@/html/elements/logo-flaubert.png" alt="Logo du Lycée Flaubert">
            </router-link >

            <!-- 
            ----------------------------------------------------------------------------------------------------------
                                                            TOGGLER SIDEBAR
            ----------------------------------------------------------------------------------------------------------
            -->
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>

            <!-- 
            ----------------------------------------------------------------------------------------------------------
                                                    NAVBAR LINK,CONTENT & DROPDOWN
            ----------------------------------------------------------------------------------------------------------
            -->
            <div class="collapse navbar-collapse" id="navbarNavDropdown">
                <div class="navbar-brand-mobile d-block d-md-none p-2">
                    <router-link  
                        class="navbar-brand"
                        :to="{ path:'/accueil'}"
                    >
                        <img src="@/html/elements/logo-flaubert.png" alt="Logo du Lycée Flaubert">
                    </router-link>
                </div>
                 <li class="dropdown"  @mouseenter="isHidden = false" v-for="(item, index) in this.$parent.dataIris.menuHeader.itemsMenu.children" :key="index" :class="index == 0 ? 'lycee-general' : index == 1 ? 'lycee-pro' : 'flaubert-sup'" >
                    <a href="#" data-toggle="dropdown" class="nav-link">
                        <span class="d-none d-md-block" v-html="chartStringBr(item.name)"></span>
                        <span class="d-block d-md-none">{{item.name}}</span>
                    </a>
                    <div class="dropdown-bg-menu"  v-show="!isHidden"></div>
                    <ul class="collapse dropdown-menu" :class="index == 0 ? 'bg-bleuvert' : index == 1 ? 'bg-orange' : 'bg-violet'"  v-if="item.children" v-show="!isHidden">
                        <div class="d-flex h-100 bigmenu">
                            <!-- PREMIERE COLONE DU BIG MENU -->
                            <div class="col-12 col-md-4 bg-white first-col col-bigmenu">
                            <h4>
                                <span v-html="chartStringBr(item.name)"></span>
                            </h4>
                            <ul>
                                <li>
                                    <a href="">
                                        <div class="bg-img">
                                            <img src="@/html/elements/login-bleu.svg" v-if="index == 0" alt="">
                                            <img src="@/html/elements/login-orange.svg" v-else-if="index == 1" alt="">
                                            <img src="@/html/elements/login-violet.svg" v-else alt="">
                                        </div>
                                        Toutes les actualités
                                    </a>
                                </li>
                                <li>
                                    <a href="contact">
                                        <div class="bg-img">
                                            <img src="@/html/elements/login-bleu.svg" v-if="index == 0" alt="">
                                            <img src="@/html/elements/login-orange.svg" v-else-if="index == 1" alt="">
                                            <img src="@/html/elements/login-violet.svg" v-else alt="">
                                        </div>
                                        Situation / Contact
                                    </a>
                                </li>
                            </ul>
                            </div>
                            <!-- DEUXIEME COLONE DU BIG MENU -->
                            <div class="col-12 col-md-8 second-col col-bigmenu">
                                <div class="row m-0">
                                    <!-- PREMIERE CATEGORIE -->
                                    <ul class="col-md-6" v-for="(subMenu, indexSubMenu) in item.children" :key="indexSubMenu">
                                        <li>
                                           <h5 v-if="subMenu.children">{{subMenu.name}}</h5>
                                           <router-link  
                                                v-else-if="subMenu.route"
                                                :to="{ name:'page-view', path:subMenu.route, params: { id : subMenu.id, route:subMenu.route }}"
                                                @click="isHidden = true"
                                            >
                                            {{subMenu.labelMenu}}
                                            </router-link>
                                            <a href="" v-else>{{subMenu.labelMenu}}</a>
                                        </li>
                                        <li v-for="(subSubMenu, indexSubSubMenu) in subMenu.children" :key="indexSubSubMenu" @click="isHidden = true">
                                            <router-link  
                                                :to="{ name:'page-view', path:subSubMenu.route, params: { id : subSubMenu.id, route:subSubMenu.route }}"
                                                @click="isHidden = true"
                                            >
                                            {{subSubMenu.labelMenu}}
                                            </router-link>
                                            <!-- <a :href="$router.resolve({name:'page-view', params: { id : subSubMenu.id, route:subSubMenu.route }}).href">
                                            {{subSubMenu.labelMenu}}
                                            </a> -->
                                            <!--<router-link :to="{ name:'page-view', path:subSubMenu.route, params: { id : subSubMenu.id, labelMenu : subSubMenu.labelMenu, route:subSubMenu.route, color:index  }}">{{subSubMenu.labelMenu}}</router-link>-->
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </ul>
                </li> 
            </div>

        </nav> 
    </div>
</template>
<script>
// FIREBASE
import "firebase/auth";
const firebase = require("firebase");
require("firebase/firestore");
require("firebase/auth");
var db = firebase.firestore();
import { firebaseConfig } from "@/firebase/firebaseConfig";

// CONFIG
import  { themeConfig, irisConfig }  from "@/../siteConfig.js";

export default {
    name: "espHeader",
    props: {
        dataPage:{
            type: Object
        }
    },
    data() {
        return {
            irisConfig:irisConfig,
            childList: [],
            childListFolder: [],
            childListFolderMove: [],
            allList: [],
            isHidden:true
        }
    },
    computed:{
        imgLogo: function () {
            if(this.dataPage.customizableVar[0].value.value){
                return require('@/html/elements/logo-'+this.dataPage.customizableVar[0].value.value+'.png')
            }else{
                return ""
            }
        },
        imgUser: function () {
            if(this.dataPage.customizableVar[0].value.value){
                return require('@/html/elements/user-'+this.dataPage.customizableVar[0].value.value+'.svg')
            }else{
                return ""
            }
        },
        customizableVar1: function () {
            if(this.dataPage.customizableVar[0].value.value){
                return this.dataPage.customizableVar[0].value.value
            }else{
                return "0f555d"
            }
        }
    },
    created() {
       this.getBrochure();
    },
    methods: {
        chartStringBr(val){
            return val.replace(' ', '<br>')
            //return val
        },
        getBrochure(){
            db.collection("customers")
                .doc(this.irisConfig.customers)
                .collection("storage")
                .onSnapshot((snap) => {
                    let fooFolder = [];
                    let fooFile = [];
                    let fooAll = [];
                    snap.forEach((doc) => {
                        if (doc.data().deleteDate == null) {
                            // if(doc.data().parent[0]=="WHRKMF77QzDtrBhkLxX6"){
                            //     fooAll.push(doc.data());
                            // }
                            fooAll.push(doc.data());
                            if ( doc.data().format == "folder" && doc.data().parent.includes("WHRKMF77QzDtrBhkLxX6")) {
                                fooFolder.push(doc.data());
                            } else if (doc.data().format == "file") {
                                fooFile.push(doc.data());
                            }
                        }
                    });
                    this.allList=fooAll
                    this.childListFolder=fooFolder
                    this.childList=fooFile
                });
        },
        filterChildFile(id){
            let childFiles = []
            this.childList.forEach(element => {
                if(element.parent.includes(id)){
                    childFiles.push(element)
                }
            });
            return childFiles.sort((a, b) => (a.caption > b.caption) ? 1 : -1);
        },
        formatNameFile(str){
            return str.replace('.pdf', '').replace('.doc', '').replace('.docx', '').replace('.xls', '').replace('.xlsx', '').replace('.ptt', '').replace('.pttx', '')
        }
    },
   
}
</script>
<style>
.form-search{
    color:#fff
}
</style>
